/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { FSxRestoreDestinationOntapRestoreOptions } from '../models/FSxRestoreDestinationOntapRestoreOptions';

export class FSxRestoreDestination {
  /**
  * AWS region where the FSx file system will be restored.
  */
  'region': string;
  /**
  * Name for the restored FSx file system.
  */
  'fileSystemName'?: string;
  /**
  * Subnet IDs for the restored file system. Required for FSx deployment.
  */
  'subnetIds': Array<string>;
  /**
  * Security group IDs for the restored file system.
  */
  'securityGroupIds'?: Array<string>;
  /**
  * KMS key ARN for encrypting the restored file system. If not provided, AWS managed encryption will be used.
  */
  'encryptionKey'?: string;
  /**
  * Storage capacity in bytes for the restored file system. If not provided, the original capacity will be used.
  */
  'storageCapacity'?: number;
  /**
  * Throughput capacity in MBps for the restored file system. If not provided, the original capacity will be used.
  */
  'throughputCapacityMBps'?: number;
  /**
  * Tags to apply to the restored file system.
  */
  'tags'?: { [key: string]: string; };
  'ontapRestoreOptions'?: FSxRestoreDestinationOntapRestoreOptions;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "fileSystemName",
      "baseName": "fileSystemName",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetIds",
      "baseName": "subnetIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "securityGroupIds",
      "baseName": "securityGroupIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "encryptionKey",
      "baseName": "encryptionKey",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageCapacity",
      "baseName": "storageCapacity",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "throughputCapacityMBps",
      "baseName": "throughputCapacityMBps",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "ontapRestoreOptions",
      "baseName": "ontapRestoreOptions",
      "type": "FSxRestoreDestinationOntapRestoreOptions",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FSxRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

